import { render } from "./supportPage.vue?vue&type=template&id=3cb9c2f7&scoped=true&ts=true"
import script from "./supportPage.vue?vue&type=script&lang=ts"
export * from "./supportPage.vue?vue&type=script&lang=ts"

import "./supportPage.vue?vue&type=style&index=0&id=3cb9c2f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb9c2f7"]])

export default __exports__